module.exports = __webpack_public_path__ + "static/media/mengjia.dbffe981.png";